import styled from "styled-components";

export const Legend = styled.div`
  position: absolute;
  z-index: 3;
  bottom: 100px;
  right: 10px;
  color: var(--color-primary);
  border-radius: 8px;
  background: rgba(255,255,255,0.9);
  padding: 10px;

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    font-size: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media (min-width: 640px) {
    bottom: 10px;

    li {
      font-size: 14px;
    }
  }
`;

export const LegendTitle = styled.div`
  font-size: 16px;
  font-family: var(--font-primary);
  color: var(--color-primary);
  margin-bottom: 10px;

  @media (min-width: 640px) {
    font-size: 14px;
  }
`;

export const LegendSwatch = styled.div`
  height: 13px;
  width: 13px;
  margin-right: 10px;
  border: 1px solid var(--color-light-gray);
  border-radius: 3px;
  background: ${(props) => props.color};
`;